import { Component, Input, OnInit } from '@angular/core';
import moment from 'moment';

// campfire
import { LoggerService } from '@campfire-nx/api';

// services
import { AppointmentService } from '@open-portal-app/appointments/services/appointment.service';

import { COMMON_CONSTANTS } from '@open-portal-app/core/constants/common.constants';

@Component({
  selector: 'app-appointment-list',
  templateUrl: './appointment-list.component.html',
  styleUrls: ['./appointment-list.component.scss']
})
export class AppointmentListComponent {
  appointmentList!: any;

  constructor(
    private appointmentService: AppointmentService,
    private loggerService: LoggerService
  ) { }

  ngOnInit(): void {
    this.appointmentService.getList()
      .then((response: any) => {
        this.appointmentList = response;
      })
      .catch((err) => {
        this.loggerService.error('AppointmentListComponent', 'ngOnInit', { error: err }, 'appointment getList');
      });
  }

  formatDay(date: string) {
    const isoDate = moment(date + 'T0:00:00Z', COMMON_CONSTANTS.dateFormats.isoDate).toDate();

    return moment(isoDate).format('MMMM Do, dddd');
  }

  formatTime(time: string) {
    return time.split('-').join(' - ');
  }

  getAppointmentText() {
    let appointmentText = 'Your appointment is on';
    for (const appointment of this.appointmentList) {
      const appointmentDate = this.formatDay(appointment.date);
      const appointmentTime = this.formatTime(appointment.time).toLowerCase();
      const textFormatPart1 = this.appointmentList.length > 1 ? '<p class="margin-none">' : '';
      const textFormatPart2 = this.appointmentList.length > 1 ? '</p>' : '';
      appointmentText = `${appointmentText}${textFormatPart1} ${appointmentDate} at ${appointmentTime}${textFormatPart2}`;
    }
    return appointmentText;
  }
}
